<template>
  <div class="dashboard-data flex flex-col w-full">
    <div
      class="title-section w-full"
      :class="{ 'flex justify-between': userType === 'admin' }"
      v-if="!isAdminOnSmMq"
    >
      <h1 class="font-bold uppercase ml-4 md:ml-0 mb-5">
        {{ title }}
      </h1>
      <div class="filters flex" v-if="userType === 'admin'">
        <div
          class="checkbox-container ml-4"
          :key="`cb_${i}`"
          v-for="(option, i) in filterOptions"
        >
          <input
            :id="$id(underSlugify(option))"
            type="checkbox"
            :value="option"
            v-model="adminDashboardFilters"
          />
          <label :for="$id(underSlugify(option))">{{ option }}</label>
        </div>
      </div>
    </div>

    <date-tab-selector v-if="!isAdminOnSmMq" />

    <mobile-dashboard-data v-if="$mq === 'sm'" />
    <desktop-dashboard-data v-else />
  </div>
</template>

<script>
import DateTabSelector from "../../elements/DateTabSelector";
import DesktopDashboardData from "./DesktopDashboardData";
import MobileDashboardData from "./MobileDashboardData";
import { CalendarTypes } from "../../constants/enums";

export default {
  name: "DashboardData",
  components: {
    MobileDashboardData,
    DesktopDashboardData,
    DateTabSelector
  },
  data() {
    return {
      filterOptions: ["Work", "Deliveries"]
    };
  },
  computed: {
    userType() {
      return this.$store.state.userType;
    },
    title() {
      if (this.$store.state.userType === "admin") {
        return "Weekly Crew View";
      }
      return "Daily Log";
    },
    isAdminOnSmMq() {
      return this.$mq === "sm" && this.userType === "admin";
    },
    adminDashboardFilters: {
      get() {
        return this.$store.state.Dashboard.adminDashboardFilters;
      },
      set(val) {
        this.$store.commit("setAdminDashboardFilters", val);
      }
    }
  },
  created() {
    this.$store.commit(
      "setSelectedCalendarType",
      this.$store.state.userType === "admin"
        ? CalendarTypes.WEEK
        : CalendarTypes.DAY
    );
    const date = this.$moment();
    this.$store.commit("setSelectedDate", date);
  }
};
</script>
